import { isBrowser } from 'Helpers/Browser';

export function getConfig(forceEnv = false) {
    if (isBrowser()) {
        return process.env;
    } else {
        const path = require('path');
        const fs = require('fs');

        const APP_ENV = forceEnv ? forceEnv : fs.readFileSync(path.join('.env'), 'utf8');
        const CONFIG = require(path.join(__dirname, '..', '..', 'config', APP_ENV + '.js'));

        CONFIG.APP_ENV = APP_ENV;
        return CONFIG;
    }
}



// WEBPACK FOOTER //
// ./src/helpers/Config.js